<template>

    <Toast/>

    <div class="px-6 surface-overlay relative">

        <div v-show="activeTab === 1" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Payment Cancelled</h3>

                    <div class="col-12 md:col-12">
                        <div class="card p-fluid">
                            <p>Payment Reference: {{ paymentReference }}</p>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>

    <IsoEvolveFooter/>

</template>

<script>
import IsoEvolveFooter from "@/components/heading/authentication/IsoEvolveFooter.vue";

export default {
    components: {
        IsoEvolveFooter
    },
    async mounted() {
        console.log("[ZarPaymentCancel][mounted] this.paymentReference = ", this.paymentReference);

        if (this.paymentReference != null) {
            this.$toast.add({
                severity: 'success',
                summary: 'Successful',
                detail: 'Transaction cancelled',
                life: 3000
            });
        }
    },
    data() {
        return {
            profile: {},
            submitted: false,
            activeTab: 1,
            paymentReference: this.$route.query.paymentReference ?? null,
        }
    },
    methods: {}
};
</script>

<style scoped>
a {
    text-decoration: none;
}
</style>
